import React, { Component } from 'react'
import styled from '@emotion/styled'
import { IHeaderParams } from 'ag-grid-community'
import { rfqIconSet } from '../shared/rfqIconSet'
import * as constants from 'view/styles/constants'

interface DeltaGroupHeaderComponentProps extends IHeaderParams {
  children: string[]
}

interface DeltaGroupHeaderComponentState {
  isColumnGroupExpanded: boolean
}

const CellWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 100%;
`

const LabelContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`

const HeaderName = styled.div<{ rightAlign: boolean }>`
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.rightAlign ? 'flex-end' : 'initial')};
  font-family: ProximaNova;
  font-weight: ${constants.FontWeight.SemiBold};
  color: ${constants.CORE_PRIMARY_6};
`

const IconContainer = styled.div`
  flex: 0 0 16px;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  color: ${constants.CORE_PRIMARY_5};
  svg {
    margin: 4px 0 0 4px;
    height: 16px;
  }
`

export class DeltaGroupHeaderComponent extends Component<DeltaGroupHeaderComponentProps, DeltaGroupHeaderComponentState> {
  state = {
    isColumnGroupExpanded: false
  }

  render() {
    const { column } = this.props
    const rightAlign = column.getColDef().type === 'numericColumn'

    return (
      <CellWrapper>
        <LabelContainer className="ag-header-cell-label" role="presentation">
          <HeaderName rightAlign={rightAlign}>{this.props.displayName}</HeaderName>
          <IconContainer className="ag-header-custom-arrow-icon" role="presentation" onClick={this.onToggleClick}>
            {this.getIcon()}
          </IconContainer>
        </LabelContainer>
      </CellWrapper>
    )
  }

  private getIcon = () => {
    const isExpanded = this.getIsColumnGroupExpanded()
    return isExpanded ? rfqIconSet.deltaArrowToggleCollapse : rfqIconSet.deltaArrowToggleExpand
  }

  private getIsColumnGroupExpanded = (): boolean => {
    const columnDefinitions = this.props.api.getColumns()
    const group = this.props.children

    if (!Array.isArray(group)) {
      return false
    }

    let displayed = 0
    columnDefinitions?.forEach(column => {
      if (group.includes(column.getColId()) && column.isVisible()) {
        displayed++
      }
    })

    return displayed === group.length
  }

  private onToggleColumnExpand = (shouldCollapse: boolean) => {
    const api = this.props.api
    api.setColumnsVisible(this.props.children, !shouldCollapse)
    this.setState({ isColumnGroupExpanded: !shouldCollapse })
  }

  private onToggleClick = () => {
    const isExpanded = this.getIsColumnGroupExpanded()
    this.onToggleColumnExpand(isExpanded)
  }
}
